var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';
export default function VeganIcon(_a) {
    var { size = 'small' } = _a, rest = __rest(_a, ["size"]);
    return (jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
        }, viewBox: "0 0 20 20" }, rest),
        jsx("path", { fill: "currentColor", d: "M15.195 8.252c-1.078 1.914-2.487 2.583-4.227 2.005-.967 1.567-1.478 3.534-1.535 5.91l-.005.45-.009-.001a.47.47 0 01-.464.384.47.47 0 01-.471-.466c0-5.249-2.055-8.652-6.19-10.305a.464.464 0 01-.26-.607.473.473 0 01.615-.257c3.35 1.34 5.462 3.755 6.328 7.207.263-.988.637-1.887 1.12-2.694a.356.356 0 01-.026-.012l.106-.12a9.188 9.188 0 012.105-2.366l.436-.488c-1.464 0-2.335.678-3.138 1.702 0 0-.687-.486-.687-1.865 0-1.23 1.304-2.27 3.403-2.27 2.642 0 3.389-1.056 3.552-1.4.24-.504.975 2.302-.653 5.193zm.138 3.498a.53.53 0 01.534.525l-.001 1.575h1.6a.53.53 0 01.534.525.53.53 0 01-.533.525h-1.601v1.575a.53.53 0 01-.533.525.53.53 0 01-.533-.525V14.9h-1.6a.53.53 0 01-.533-.525.53.53 0 01.533-.525h1.6v-1.575a.53.53 0 01.533-.525z" })));
}
//# sourceMappingURL=VeganIcon.js.map